<template>
  <v-card flat>
    <v-form
      v-model="isValid"
      class="form-share"
    >
      <v-text-field
        v-model="shareholder"
        :rules="rules.text"
        label="Shareholder"
        :counter="MAX_LENGTH"
        :disabled="isReadOnly"
        required
        autofocus
      />
      <v-text-field
        v-model="shareEmail"
        :rules="rules.email"
        :disabled="isReadOnly"
        :counter="MAX_LENGTH"
        label="Email"
        type="email"
        required
      />
      <v-text-field
        v-model="certificateNumber"
        :rules="rules.text"
        :disabled="isReadOnly"
        :counter="MAX_LENGTH"
        label="Certificate Number"
        required
      />
      <v-text-field
        v-model="noIssued"
        :rules="rules.number"
        :disabled="isReadOnly"
        :counter="MAX_LENGTH"
        label="No. Issued Shares"
        type="number"
        required
      />
      <v-select
        v-model="shareType"
        :items="shareTypeList"
        :rules="rules.selectOne(shareTypeList)"
        :disabled="isReadOnly"
        label="Type"
        required
      />
      <v-select
        v-if="isShTypeOrdinary()"
        v-model="shareTypeClass"
        :items="shareTypeClassList"
        :rules="rules.selectOne(shareTypeClassList)"
        :disabled="isReadOnly"
        label="Share Class"
        required
      />
      <v-select
        v-model="series"
        :items="seriesList"
        :rules="rules.selectOne(seriesList)"
        :disabled="isReadOnly"
        label="Series"
        required
      />
    </v-form>
    <v-card-actions v-if="!isReadOnly">
      <v-btn
        color="primary"
        text
        large
        @click.stop="onCancelClick"
      >
        {{ textActionSecondBtn }}
      </v-btn>
      <v-btn
        :disabled="!isValid"
        :loading="loading"
        color="primary"
        large
        @click.stop="onSubmitData"
      >
        {{ textActionBtn }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="isReadOnly">
      <v-btn
        color="primary"
        text
        large
        @click.stop="onRemove"
      >
        {{ textActionDeleteBtn }}
      </v-btn>
      <v-btn
        :loading="loading"
        color="primary"
        large
        @click.stop="onEdit"
      >
        {{ textActionEditBtn }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { v4 as uuidv4 } from 'uuid'
import { firebase } from '@/firebase'

const SHARE_TYPES = ['Ordinary', 'Preference', 'Partly Paid', 'Non-voting']
const SHARE_TYPE_CLASS = ['Class A', 'Class B']
const SHARE_SERIES = ['Founders', 'A', 'B', 'C']

export default {
  name: 'FormShare',
  props: {
    loading: { type: Boolean, default: false },
    shareValues: { type: Object, default: null },
    textActionBtn: { type: String, default: 'Save' },
    textActionSecondBtn: { type: String, default: 'Cancel' },
    textActionDeleteBtn: { type: String, default: 'Remove' },
    textActionEditBtn: { type: String, default: 'Edit' }
  },
  data: function () {
    return {
      uuid: null,
      isValid: false,
      shareholder: null,
      shareEmail: null,
      certificateNumber: null,
      noIssued: null,
      shareType: null,
      shareTypeClass: null,
      series: null,
      seriesList: SHARE_SERIES,
      shareTypeList: SHARE_TYPES,
      shareTypeClassList: SHARE_TYPE_CLASS,
      isReadOnly: false,
      MAX_LENGTH: 40,
      rules: {
        text: [value => this.rulesAction(value, 'text')],
        number: [value => this.rulesAction(value, 'number')],
        email: [value => this.rulesAction(value, 'email')],
        selectOne: (list) => [value => this.rulesAction(value, 'selectOne', list)]
      }
    }
  },
  beforeMount() {
    this.setLocalValues(this.shareValues)
  },
  methods: {
    isShTypeOrdinary() {
      if (this.shareType === 'Ordinary') {
        return true
      }

      this.shareTypeClass = null
      return false
    },
    onSubmitData() {
      const formData = {
        uuid: this.uuid || uuidv4(),
        email: this.shareEmail,
        certificateNumber: this.certificateNumber,
        series: this.series,
        noIssued: Number(this.noIssued),
        shareType: this.shareType,
        shareholder: this.shareholder,
        shareTypeClass: this.shareTypeClass,
        dateIssued: firebase.firestore.Timestamp.now()
      }

      this.setLocalValues({})
      this.$emit('onSubmitData', formData)
    },
    onRemove() {
      this.setLocalValues({})
      this.$emit('onSubmitData')
    },
    onEdit() {
      this.isReadOnly = false
    },
    onCancelClick() {
      this.setLocalValues({})
      this.$emit('onCancelClick', 'shares')
    },
    setLocalValues(values) {
      if (values) {
        this.isReadOnly = !!values.uuid
        this.uuid = values.uuid || null
        this.shareholder = values.shareholder || null
        this.shareEmail = values.email || null
        this.certificateNumber = values.certificateNumber || null
        this.noIssued = values.noIssued || null
        this.shareType = values.shareType || null
        this.shareTypeClass = values.shareTypeClass || null
        this.series = values.series || null
      }
    },
    rulesAction(value, type, options) {
      if (!value) {
        return 'This field is required.'
      }

      switch (type) {
      case 'email':
        const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        return pattern.test(value) || 'E-mail must be valid'
      case 'text':
        return value.length <= this.MAX_LENGTH || `Max ${this.MAX_LENGTH} characters`
      case 'number':
        return typeof parseInt(value, 10) === 'number' || 'Just numbers are accepted'
      case 'selectOne':
        return options.includes(value) || 'Select a valid option from the list'
      }
    }
  }
}
</script>
